import { EQUIPMENT_GROUP_NAMES, EQUIPMENT_GROUPS, homeEquipmentIds, } from "@repo/contract/training";
/**
 * The rows into the four groups, groups in `EQUIPMENT_GROUP_NAMES` order, rows
 * in the catalogue's own order within each. An id the contract does not know
 * lands in `accessories` rather than vanishing: a hidden row is a thing the
 * person owns that the engine believes they do not.
 */
export function groupEquipment(rows) {
    return EQUIPMENT_GROUP_NAMES.map((group) => ({
        group,
        labelKey: `equipment.group.${group}`,
        rows: rows.filter((row) => (EQUIPMENT_GROUPS[row.id] ?? "accessories") === group),
    })).filter((entry) => entry.rows.length > 0);
}
export function toggleEquipment(selected, id) {
    const next = new Set(selected);
    if (next.has(id)) {
        next.delete(id);
    }
    else {
        next.add(id);
    }
    return next;
}
/** *Full gym*: every catalogue row ticked; the person then unticks. */
export function fullGymSelection(rows) {
    return new Set(rows.map((row) => row.id));
}
/** *Home*: body weight plus the three home free weights; the person then
 *  unticks what they do not own. */
export function homeSelection() {
    return new Set(homeEquipmentIds());
}
//# sourceMappingURL=equipment-selection.js.map